var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('app-navigation',{class:{ 'nav-screensaver' : _vm.$route.name === 'screensaver' }}),_c('div',{class:[
      'view',
      { 'blue' : _vm.$route.name === 'index' || _vm.$route.name === 'cart-payment-methods'
         || _vm.$route.name === 'cart-app-payment' },
      { 'screensaver-holder' : _vm.$route.name === 'screensaver' }
    ]},[_c('transition',{attrs:{"name":"fade-slow","mode":"out-in"}},[_c('router-view')],1)],1),(false)?_c('app-footer'):_vm._e(),(_vm.isIdle)?_c('idle'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }